import { formatCurrency } from '../../services/currency/utility_currency';

export function calculateQuantityBreaks(pricebook) {
  const {
    price_levels,
    tax_rate,
    currency: { code: currencyCode },
    retail_price,
  } = pricebook;

  const opts = { maximumFractionDigits: 6 };
  (price_levels || []).forEach((priceLevel) => {
    (priceLevel.quantity_break || []).forEach((qb) => {
      qb.discount_percent = Number(qb.discount_percent);

      const discountPct = qb.discount_percent / 100;

      qb.rate = Number(qb.rate || 0);

      if (qb.rate) {
        qb.rate_inc_tax = formatCurrency(
          qb.rate + qb.rate * (tax_rate || 0),
          currencyCode,
        );
      } else {
        const retailPrice = Number(retail_price);
        const rate = retailPrice - retailPrice * discountPct;
        qb.rate = formatCurrency(rate, currencyCode, opts);
        qb.rate_inc_tax = formatCurrency(
          rate + rate * (tax_rate || 0),
          currencyCode,
        );
      }

      const quantityPrice = Number(qb.quantity_price);
      if (quantityPrice) {
        qb.quantity_price_inc_tax = formatCurrency(
          quantityPrice + quantityPrice * (tax_rate || 0),
          currencyCode,
        );
      } else {
        const quantity = Number(qb.quantity);
        const rate = Number(qb.rate);
        const rateIncTax = Number(qb.rate_inc_tax);
        qb.quantity_price = formatCurrency(rate * quantity, currencyCode, opts);
        qb.quantity_price_inc_tax = formatCurrency(
          rateIncTax * quantity,
          currencyCode,
        );
      }
    });
  });


  return sortPriceLevels(price_levels);
}

function sortPriceLevels(priceLevels) {
  return priceLevels.map((priceLevel) => {
    priceLevel.quantity_break.sort((a, b) => a.quantity - b.quantity);
    return priceLevel;
  });
}
